<script setup lang="ts">
import { X } from '@lucide/vue'

defineEmits<{
  click: [event: MouseEvent]
}>()
</script>

<template>
  <div
    @click="$emit('click', $event)"
    class="ml-5 rounded-full h-11 w-11 border-border bg-gray-100 text-gray-400 hover:bg-gray-200 hover:text-gray-600 dark:bg-gray-700 dark:bg-white/[0.05] dark:text-gray-400 dark:hover:bg-white/[0.07] dark:hover:text-gray-300 p-1 flex items-center justify-center cursor-pointer"
  >
    <X class="size-5" />
  </div>
</template>
